import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInitiatives: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconInitiatives"><Path d="M7 20L12 10L17 20L12 17.7778L7 20Z" stroke="currentColor" strokeLinecap="square"/><Path d="M3.63131 16.5C2.90957 15.1606 2.5 13.6281 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 13.6281 21.0904 15.1606 20.3687 16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconInitiatives;
